import MaintenanceScheduleI from '@interfaces/practititoner/maintenance';
import axiosApiInstance from '@services/custom-axios-instance';
import { generateUrl } from "@services/generateUrl/generateUrl";

export function getMaintenanceSchedule() {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drprox/maintenance/dr-prox/`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as MaintenanceScheduleI;
        });
}
